const { createAdHtml, createInsertNewAdFunction, syncPlacedAdCountFromDom } = require('./adInsertion');
const { ensureAdSlotMinHeight } = require('./adSizeUtils');
const { waitForArticleEndSlot } = require('./insights/articleEndSlot');
const { logWarn } = require('./logger');

const EMBED_SELECTOR = '.rm-embed-container, .rm-shortcode, .rm-embed-holder, .rm-embed-spacer, iframe, .instagram-media';
const WIDGET_SELECTOR = '.ad-wrapper, .content-ad, .separator, .related-post, .stories-player-container, .milla-newsletter-embed, .milla-contest-embed, .milla-insights-embed';

function shouldShowMemberAds(ctx) {
  return ctx.isLoggedIn === true
    && ctx.pro !== 'active'
    && ctx._noads !== 'yes'
    && ctx._urlonly !== 'yes'
    && ctx._sponsored !== 'yes';
}

// Run after the standard article placements so these replacements share the
// content-slot counter and never stack against an existing ad break.
function setupMemberArticleAds(ctx, { device, slotPrefix, minHeight, prepareSlot }) {
  if (typeof document === 'undefined' || !shouldShowMemberAds(ctx)) return;

  const mobile = device === 'mobile';
  const insertAd = createInsertNewAdFunction(slotPrefix, minHeight, { prepareSlot });

  function placeAd(location) {
    try {
      const container = document.querySelector('.body-description')
        || document.querySelector('article')
        || document.querySelector('.article-body');
      const markerClass = `milla-member-ad-${location}`;
      if (!container || container.querySelector(`.${markerClass}`)) return;
      if (location === 'end' && container.querySelector('.milla-contest-embed, .milla-insights-embed')) return;

      const paragraphs = Array.from(container.querySelectorAll('p')).filter((p) => (
        (p.textContent || '').trim() && !p.closest(`${EMBED_SELECTOR}, ${WIDGET_SELECTOR}`)
      ));
      const minParagraphs = location === 'mid' || mobile ? 4 : 7;
      if (paragraphs.length < minParagraphs) return;

      const paragraph = location === 'mid' ? paragraphs[3] : paragraphs[paragraphs.length - 1];
      // Keep inventory outside listicle sections and other nested content.
      let anchor = paragraph;
      while (anchor.parentElement && anchor.parentElement !== container) {
        anchor = anchor.parentElement;
      }
      if (anchor.parentElement !== container) return;
      if (anchor.querySelector(WIDGET_SELECTOR)) return;
      if ([anchor.previousElementSibling, anchor.nextElementSibling].some((sibling) => (
        sibling && (sibling.matches(WIDGET_SELECTOR) || sibling.querySelector(WIDGET_SELECTOR))
      ))) return;

      syncPlacedAdCountFromDom(slotPrefix);
      const slotId = insertAd(anchor);
      if (slotId) anchor.nextElementSibling.classList.add(markerClass);
    } catch (err) {
      logWarn('Failed to inject member article ad', err);
    }
  }

  function inject() {
    if (!mobile) placeAd('mid');
    // Surveys, predictions, and contests retain priority at article end.
    waitForArticleEndSlot().then((occupied) => {
      if (!occupied) placeAd('end');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject, { once: true });
  } else {
    inject();
  }
}

// Section injection mounts this container; the existing viewport observer
// then defines, auctions, and refreshes it as normal homepage inventory.
function createMemberSectionAd(ctx, { slotPrefix, minHeight }) {
  if (typeof document === 'undefined' || !shouldShowMemberAds(ctx)) return null;
  syncPlacedAdCountFromDom(slotPrefix);
  window.adData.placedAdCount += 1;
  const slotId = `${slotPrefix}-${window.adData.placedAdCount}`;
  const holder = document.createElement('div');
  holder.innerHTML = createAdHtml(slotId, minHeight);
  ensureAdSlotMinHeight(holder.querySelector('.content-ad'), minHeight);
  return holder.firstElementChild;
}

module.exports = { setupMemberArticleAds, createMemberSectionAd };
